import { call, put, select } from 'redux-saga/effects';
import { selectCallStack, setCurrentState, setCallStack } from '../../../state/routeStack/routeStackSlice';
import { getNavigate } from '../../../services/router/router';

export default function* callStackPush({ payload }) {
  const navigate = yield call(getNavigate);
  const stack = yield select(selectCallStack);
  yield put(setCurrentState(payload));
  yield put(setCallStack([...stack, payload]));
  navigate(payload.route, { state: payload.state });
}
